module.exports = __webpack_public_path__ + "static/pirate-2b0df11e81efd0477bd80b6892b985ff.svg";